/* eslint-disable @typescript-eslint/naming-convention */
import type { IInfiniteDoctorsResponse } from "../../types";

import classes from "./styles.module.scss";

import type { IMetaOption } from "@/interfaces";
import { Avatar } from "@/components/atoms/avatar";
import { Typography } from "@/components/atoms/typography";
import { Icon } from "@/components/atoms/icons";

export function DoctorItem(props: IMetaOption<IInfiniteDoctorsResponse>) {
  const {
    avatar,
    current_facility,
    first_name,
    last_name,
    user_id,
    value,
    speciality,
  } = props;

  return (
    <div className={classes.card}>
      <Avatar
        size={"small"}
        userInfo={{
          firstName: first_name,
          lastName: last_name,
          imageUrl: avatar?.url,
        }}
        variant={44}
      />
      <div className={classes.cardText}>
        <div className={classes.cardTopRow}>
          <Typography
            fontWeight={"semi-bold"}
            fontFamily={"dana"}
            fontSize={"md-high"}
          >
            {value}
          </Typography>
          {user_id && (
            <Typography
              fontFamily={"dana"}
              fontSize={"xs"}
              variant={"caption1"}
            >
              {user_id}
            </Typography>
          )}
        </div>
        <div className={classes.cardTopRow}>
          <div>
            <Typography fontSize={"sm"} color={"secondary-text"}>
              {speciality?.value}
            </Typography>
          </div>
          {current_facility && (
            <div className={"d-flex gap-xs1"}>
              <Icon
                name={"Hospital"}
                fontSize={"sm"}
                color={"secondary-text"}
              />
              <Typography
                fontFamily={"dana"}
                fontSize={"sm"}
                fontWeight={"regular"}
              >
                {current_facility.name}
              </Typography>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
